// extracted by mini-css-extract-plugin
export var bestInFieldSection = "bestInField-module--bestInFieldSection--rwliT";
export var bestInFieldUpperText = "bestInField-module--bestInFieldUpperText--tAksC";
export var bestInFieldUpperTextSVG = "bestInField-module--bestInFieldUpperTextSVG--p8dEZ";
export var bestInFieldUpperImgsWrapper = "bestInField-module--bestInFieldUpperImgsWrapper--jLhnS";
export var bestInFieldImg = "bestInField-module--bestInFieldImg--n9oKm";
export var bestInFieldImgContent = "bestInField-module--bestInFieldImgContent--8GUUn";
export var bestInFieldBottomText = "bestInField-module--bestInFieldBottomText--0p19D";